import img1 from 'assets/thumbnails/photos/TACO1.jpg';
import img2 from 'assets/thumbnails/photos/TACO2.jpg';
import img3 from 'assets/thumbnails/photos/TACO3.jpg';
import img4 from 'assets/thumbnails/photos/1.jpg';
import img5 from 'assets/thumbnails/photos/2.jpg';
import img6 from 'assets/thumbnails/photos/3.jpg';
import img7 from 'assets/thumbnails/photos/2.1.jpg';
import img8 from 'assets/thumbnails/photos/2.2.jpg';
import img9 from 'assets/thumbnails/photos/2.3.jpg';
import img10 from 'assets/thumbnails/photos/3.1.jpg';
import img11 from 'assets/thumbnails/photos/3.2.jpg';
import img12 from 'assets/thumbnails/photos/3.3.jpg';

export const photos = [
  {
    id: 1,
    image: img1,
    link: 'https://www.instagram.com/p/BiKREbzgcZN/',
  },
  {
    id: 2,
    image: img2,
    link: 'https://www.instagram.com/p/BiKI4ZwgMcV/',
  },
  {
    id: 3,
    image: img3,
    link: 'https://www.instagram.com/p/BiJbYsvg_VB/',
  },
  {
    id: 4,
    image: img4,
    link: 'https://www.instagram.com/p/Bu316BRg4cf/',
  },
  {
    id: 5,
    image: img5,
    link: 'https://www.instagram.com/p/Bp7HsfgAjOw/',
  },
  {
    id: 6,
    image: img6,
    link: 'https://www.instagram.com/p/Bk2RApDgChq/',
  },
  {
    id: 7,
    image: img7,
    link: 'https://www.instagram.com/p/BsidaHJgyeU/',
  },
  {
    id: 8,
    image: img8,
    link: 'https://www.instagram.com/p/BtS1a1UAQZd/',
  },
  {
    id: 9,
    image: img9,
    link: 'https://www.instagram.com/p/Bqapl83gmmG/',
  },
  {
    id: 10,
    image: img10,
    link: 'https://www.instagram.com/p/Bu1gv2eAnGQ/',
  },
  {
    id: 11,
    image: img11,
    link: 'https://www.instagram.com/p/BtqK6-Jg176/',
  },
  {
    id: 12,
    image: img12,
    link: 'https://www.instagram.com/p/BkkKBzvAtr6/',
  },
];
